import { makeStyles } from "tss-react/mui";
import { Box, Tooltip } from "@mui/material";
import { COLUMN_WIDTH } from "./chartView.constants";
import { OrderTemplateNodeData } from "./chartView.types";

export const OrderTemplateNode = ({
  data,
}: {
  data: OrderTemplateNodeData;
}) => {
  const { classes } = useStyles();

  const label = `${data.name} Order`;

  return (
    <Tooltip title={label} placement="top" arrow>
      <Box className={classes.card}>{label}</Box>
    </Tooltip>
  );
};

const useStyles = makeStyles()((theme) => ({
  card: {
    display: "flex",
    backgroundColor: theme.palette.purple.light,
    border: "1px solid #DAC2FF",
    borderRadius: theme.spacing(1),
    color: theme.palette.deepPurple.medium,
    fontWeight: theme.fontWeight.semiBold,
    fontSize: theme.fontSize.small,
    padding: theme.spacing(3, 3),
    boxShadow: "0px 1px 2px 0px #0000000F",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: COLUMN_WIDTH,
    boxSizing: "border-box",
  },
}));
